import { render } from "./errorPage5.vue?vue&type=template&id=e24f71ec&scoped=true"
const script = {}

import "./errorPage5.vue?vue&type=style&index=0&id=e24f71ec&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24f71ec"]])

export default __exports__